module.exports = __webpack_public_path__ + "img/Commodity.6d9ac94e.png";